import { Box, Heading, SimpleGrid, Text } from "@chakra-ui/react";
import { FaAward, FaBriefcase, FaCode, FaMapMarkerAlt } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";
import { pick, useProfile } from "../hooks/useContent";
import { countryFlag } from "../utils/countryFlag";
import { StatsSkeleton } from "./ui/Skeletons";
import { SkeletonText } from "@chakra-ui/react";
import Section from "./ui/Section";

const iconMap = {
  code: FaCode,
  briefcase: FaBriefcase,
  award: FaAward,
  map: FaMapMarkerAlt,
};

function StatCard({ stat, language }) {
  const Icon = iconMap[stat.icon] || FaCode;
  const label = language === "es" ? stat.label_es : stat.label_en;
  const sublabel = language === "es" ? stat.sublabel_es : stat.sublabel_en;
  // For the location stat, show the country flag if we recognize the country.
  const flag = stat.icon === "map" ? countryFlag(stat.value) : "";

  return (
    <Box
      bg="bg.card"
      border="1px solid"
      borderColor="border.card"
      rounded="xl"
      p={6}
    >
      <Box
        bg="blue.600"
        rounded="lg"
        w={10}
        h={10}
        display="flex"
        alignItems="center"
        justifyContent="center"
        mb={4}
        fontSize="xl"
      >
        {flag ? <span>{flag}</span> : <Icon color="white" size={20} />}
      </Box>
      <Heading fontSize="2xl" color="text.heading" mb={1}>
        {stat.value}
      </Heading>
      <Text color="text.heading" fontWeight="medium">
        {label}
      </Text>
      {sublabel && (
        <Text color="text.muted" fontSize="sm" mt={1}>
          {sublabel}
        </Text>
      )}
    </Box>
  );
}

export default function About() {
  const { language } = useLanguage();
  const { data: p, loading } = useProfile();

  const stats = p?.stats || [];
  const aboutText = pick("about", p, language);

  return (
    <Section
      id="about"
      eyebrow={language === "es" ? "SOBRE MÍ" : "ABOUT ME"}
      title={language === "es" ? "Más información sobre mí" : "More about me"}
    >
      {loading ? (
        <>
          <SkeletonText maxW="2xl" mb={10} noOfLines={3} spacing={3} />
          <StatsSkeleton />
        </>
      ) : (
        <>
          <Text
            color="text.muted"
            w="100%"
            maxW="none"
            mb={10}
            fontSize={{ base: "lg", md: "xl" }}
            lineHeight="1.8"
          >
            {aboutText}
          </Text>
          <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={6}>
            {stats.map((stat, i) => (
              <StatCard key={i} stat={stat} language={language} />
            ))}
          </SimpleGrid>
        </>
      )}
    </Section>
  );
}
